/* Text scramble / decode — Weblove Template 12 mechanic (locked). */
const GLYPHS = "!<>-_\\/[]{}—=+*^?#@$%&AXKZR0147";

export function scrambleTo(el, text, { charTime = 45, perCharDelay = 3 } = {}) {
  if (!el) return;
  if (el.__anim) cancelAnimationFrame(el.__anim);
  const from = el.textContent;
  const len = Math.max(from.length, text.length);
  const queue = [];
  for (let i = 0; i < len; i++) {
    const start = i * perCharDelay + Math.floor(Math.random() * 4);
    const dur = Math.floor(Math.random() * 5) + 4;
    queue.push({ to: text[i] || "", start, end: start + dur });
  }
  let frame = 0;
  let last = 0;
  const chOut = (c) => (c === " " ? "&nbsp;" : c || "");
  function step(now) {
    if (now - last >= charTime) {
      last = now;
      frame++;
      let out = "";
      let done = 0;
      for (let i = 0; i < queue.length; i++) {
        const q = queue[i];
        if (frame >= q.end) {
          out += `<span class="ch">${chOut(q.to)}</span>`;
          done++;
        } else if (frame >= q.start) {
          out += `<span class="ch junk">${GLYPHS[Math.floor(Math.random() * GLYPHS.length)]}</span>`;
        } else {
          out += `<span class="ch">${chOut(from[i])}</span>`;
        }
      }
      el.innerHTML = out;
      if (done === queue.length) return;
    }
    el.__anim = requestAnimationFrame(step);
  }
  el.__anim = requestAnimationFrame(step);
}
